import React from "react";
import clsx from "clsx";

import { ReactComponent as ArrowRightSingleIcon } from "../../assets/svg/arrow_right_single.svg";
import { OnePagePortfolioAssessments } from "../../state";

import styles from "./BaWorkSection.module.scss";

type Props = {
  oppas: OnePagePortfolioAssessments[] | null;
};

const BaWorkSection: React.FC<Props> = ({ oppas }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  if (!oppas || oppas.length === 0) return null;

  return (
    <div className={styles.accordionBlock}>
      <div
        className={styles.accordionHeader}
        onClick={() => setIsOpen(prev => !prev)}
      >
        <ArrowRightSingleIcon
          className={clsx(styles.accordionArrow, isOpen && styles.open)}
        />
        <span>学習前後の考えの変化</span>
      </div>
      {isOpen && (
        <div className={styles.accordionContent}>
          {oppas.map(oppa => {
            const label = oppa.title.includes("Before")
              ? "Before WORK"
              : "After WORK";
            const questions = oppa.one_page_portfolio_assessment_issues.flatMap(
              issue => issue.one_page_portfolio_assessment_questions,
            );
            return (
              <div key={oppa.id} className={styles.baItem}>
                <span className={styles.issueTitle}>{label}</span>
                {questions.map(question => {
                  const answer = question.one_page_portfolio_assessment_answer;
                  if (!answer) return null;
                  return (
                    <div key={question.id} className={styles.qaItem}>
                      <p className={styles.question}>{question.title}</p>
                      <p className={styles.answer}>{answer.contents ?? ""}</p>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default BaWorkSection;
